import { useMutation } from '@tanstack/react-query';
import { SuggestedTaskItem, TaskItem } from '@demind-inc/core';

import { schedulerApi, TemporaryTask } from '../api';

interface UseSuggestIndividualTaskTimeParams {
  userId: string;
  metricId: string;
  preferenceId: string;
  currentTime: string;
  task: Partial<TaskItem>;
  temporaryTasks?: TemporaryTask[];
  signal?: AbortSignal;
}

export const useSuggestIndividualTaskTime = () => {
  const suggestIndividualTaskTimeMutation = useMutation({
    mutationFn: async ({
      userId,
      metricId,
      preferenceId,
      currentTime,
      task,
      temporaryTasks,
      signal,
    }: UseSuggestIndividualTaskTimeParams) => {
      const response = await schedulerApi.suggestIndividualTaskTime(
        {
          userId,
          metricId,
          preferenceId,
          currentTime,
          task,
          temporaryTasks,
        },
        { signal }
      );

      const res = response.data;
      return {
        ...res,
      };
    },
  });

  return {
    suggestIndividualTaskTime: suggestIndividualTaskTimeMutation.mutateAsync,
    ...suggestIndividualTaskTimeMutation,
  };
};
